import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "main-title" }
const _hoisted_2 = { class: "bg-text" }
const _hoisted_3 = { class: "about-container" }
const _hoisted_4 = ["dir"]
const _hoisted_5 = { class: "right-about" }
const _hoisted_6 = { class: "abt-text" }
const _hoisted_7 = { class: "large-text" }
const _hoisted_8 = { class: "small-text" }
const _hoisted_9 = { class: "about-stats" }
const _hoisted_10 = { class: "stat-title" }
const _hoisted_11 = { class: "progress-bars" }
const _hoisted_12 = { class: "prog-title" }
const _hoisted_13 = { class: "progress-con" }
const _hoisted_14 = { class: "prog-text" }
const _hoisted_15 = { class: "progress" }
const _hoisted_16 = { class: "stat-title" }
const _hoisted_17 = ["dir"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "tl-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-briefcase" })
], -1)
const _hoisted_19 = { class: "tl-duration" }

import CV from '@/components/DownloadCV.vue'
  import { ref, computed } from 'vue'
  import { useI18n } from 'vue-i18n';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  setup(__props) {

  const { locale } = useI18n();
  const { t } = useI18n();

  const isRTL = computed(() => {
  return locale.value === 'ar'; // 'ar' is the code for Arabic
  });
  // About text
  const aboutText = t('about.description');

  // Stats information
  const stats = [
  { value: "7+", title: "projectsCompleted" },
  { value: "3+", title: "yearsOfExperience" },
  { value: "20+", title: "technologyMastered" },
  { value: "10+", title: "certifications" },
 ];
  
  // Skills information
  const skills = [
    { name: "Python", proficiency: 85 },
    { name: "Flask", proficiency: 80 },
    { name: "JavaScript", proficiency: 70 },
    { name: "PHP", proficiency: 70 },
    { name: ".NET (C#)", proficiency: 50 },
    { name: "C", proficiency: 40 },
    { name: "Symfony 3/4/5", proficiency: 50 },
    { name: "Shell scripting", proficiency: 70 },
    { name: "Batch scripting", proficiency: 70 },
    { name: "Rest API", proficiency: 80 },
    { name: "GraphQL API", proficiency: 70 },
    { name: "HTML/CSS", proficiency: 90 },
    { name: "Bootstrap/ Tailwind css", proficiency: 80 },
    { name: "Github action", proficiency: 60 },
    { name: "Jenkins", proficiency: 70 },
    { name: "Terraform", proficiency: 50 },
    { name: "Docker", proficiency: 60 },
    { name: "Software testing (ISTQB)", proficiency: 70 },
    { name: "Task automation", proficiency: 80 },
    { name: "Cloud AWS/Azure", proficiency: 80 },
    { name: "Shopify API", proficiency: 80 },
    { name: "Power BI", proficiency: 80 },
    { name: "Mysql/SQL server databases/Postgress", proficiency: 75 },
    { name: "Fastify", proficiency: 65},
    { name: "TypeScript", proficiency: 60},
    { name: "Vue js", proficiency: 75},
  ];
  
  // Timeline information
  const timelines = [
    {
      duration: "2024 - Now",
      title: "frontendDeveloper",
      company: "Rimans Solution",
      description: "timelineDescription1",
    },
    {
      duration: "2023 - 2024",
      title: "powerPlatformDeveloper",
      company: "Rimans Solution",
      description: "timelineDescription2",
    },
    {
      duration: "2023",
      title: "ciTester",
      company: "OPAL-RT/Rimans Solution",
      description: "timelineDescription3",
    },
    {
      duration: "2022",
      title: "dataAnalyst",
      company: "ZMWARELAB",
      description: "timelineDescription4",
    },
    {
      duration: "2021",
      title: "devOps",
      company: "ZMWARELAB",
      description: "timelineDescription5",
    },
  ];
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('about.title')) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('about.subtitle')), 1),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('about.bgText')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "left-about",
        dir: isRTL.value ? 'rtl' : 'ltr'
      }, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t('about.informationTitle')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('about.description')), 1),
        _createVNode(CV)
      ], 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(stats, (stat) => {
          return _createElementVNode("div", {
            class: "about-item",
            key: stat.title
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(stat.value), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t(`about.stats.${stat.title}`)), 1)
            ])
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.$t('about.skillsTitle')), 1),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(skills, (skill) => {
          return _createElementVNode("div", {
            class: "progress-bar",
            key: skill.name
          }, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(skill.name), 1),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("p", _hoisted_14, _toDisplayString(skill.proficiency) + "%", 1),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", {
                  class: _normalizeClass('rate' + skill.proficiency)
                }, null, 2)
              ])
            ])
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.$t('about.timelineTitle')), 1),
    _createElementVNode("div", {
      class: "timeline",
      dir: isRTL.value ? 'rtl' : 'ltr'
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(timelines, (timeline) => {
        return _createElementVNode("div", {
          class: "timeline-item",
          key: timeline.duration
        }, [
          _hoisted_18,
          _createElementVNode("p", _hoisted_19, _toDisplayString(timeline.duration), 1),
          _createElementVNode("h5", null, [
            _createTextVNode(_toDisplayString(_ctx.$t(`about.timeline.${timeline.title}`)), 1),
            _createElementVNode("span", null, " - " + _toDisplayString(timeline.company), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t(`about.timeline.${timeline.description}`)), 1)
        ])
      }), 64))
    ], 8, _hoisted_17)
  ], 64))
}
}

})